"use client";

import React, { useEffect, useRef } from "react";
import hairred1 from "../assets/HairReduction/img12.png";
import bodyscup1 from "../assets/bodysculpting/img1.png";
import pigment1 from "../assets/pigmentremoval/img1.png";
import hairred2 from "../assets/HairReduction/img2.png";
import analysers1 from "../assets/analysers/img1.png";
import hydra1 from "../assets/hydrafacial/img1.png";
import skinlift1 from "../assets/skinlifting/img1.png";


import pigment from '../assets/icons/Pigment-Removal.webp'
import haired from '../assets/icons/Hair-Reducation.webp'
import skintight from '../assets/icons/Skin-Tightening.webp'
import analy from '../assets/icons/analysers.webp'
import skinlift from '../assets/icons/Skin-Lifting.webp'
import hydra from '../assets/icons/Hydra-facial.webp'
import bodysc from '../assets/icons/Body-Sculpting.webp'
import hairgrowth from '../assets/icons/Hair-regrowth.webp'

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ServicePage from "../components/ServicePage";
gsap.registerPlugin(ScrollTrigger);

const SectionCards = () => {
  const sectionRef = useRef(null);
  const mockupRef = useRef(null);
  const titleRef = useRef(null);

  const cardRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const animateCards = (cards, xPos) => {
    gsap.fromTo(
      cards,
      { opacity: 0, x: xPos },
      {
        opacity: 1,
        x: 0,
        duration: 1,
        ease: "power4.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top center",
          toggleActions: "play none none reverse",
        },
      }
    );
  };

  useEffect(() => {
    const mockupPhone = mockupRef.current;
    const title = titleRef.current;

    gsap.fromTo(
      mockupPhone,
      {
        opacity: 0,
        scale: 0.5,
      },
      {
        opacity: 1,
        scale: 1,
        duration: 1,
        ease: "power4.out",
      }
    );

    gsap.fromTo(
      title,
      {
        opacity: 0,
        y: 100,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1.5,
        ease: "power4.out",
        scrollTrigger: {
          trigger: title,
          start: "50% center",
        },
      }
    );

    const card01 = cardRefs[0].current;
    const card02 = cardRefs[1].current;
    const card03 = cardRefs[2].current;
    const card04 = cardRefs[3].current;
    const card05 = cardRefs[4].current;
    const card06 = cardRefs[5].current;
    const card07 = cardRefs[6].current;
    const card08 = cardRefs[7].current;

    const leftImages = [card01, card02, card03, card04];
    const rightImages = [card05, card06, card07, card08];

    animateCards(leftImages, 50);
    animateCards(rightImages, -50);
  }, []);

  return (
    <>
      <section ref={sectionRef} className="relative w-full lg:min-h-screen py-20 ">
        <img
          ref={mockupRef}
          src={hairred1}
          alt="Main mockup"
          className="opacity-0 lg:sticky  top-[200px] relative  w-[450px] mx-auto -mt-[48rem] lg:mb-16 z-10"
          // style={{ transform: "translateY(-50%)" }}
        />
        <h2
          ref={titleRef}
          className="text-center hidden lg:block text-4xl font-semibold text-black lg:mb-56 opacity-0"
        >
          Services at <span className="text-colorPrimary">Derma Rays</span>
        </h2>

        <div className="relative hidden bottom-[200px] lg:block w-full max-w-images-cards mx-auto h-images-cards  rounded-lg  p-6">
  {/* Hair Reduction */}

  <div className="absolute top-8 left-44 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[0]}
      src={haired}
      alt="imgm 1"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <div className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Hair Reduction
    </div>
  </div>

  {/* Pigment Removal */}
  <div className="absolute top-40 left-0 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[1]}
      src={pigment}
      alt="imgm 2"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Pigment Removal
    </p>
  </div>

  {/* Body Sculpting */}
  <div className="absolute bottom-0 left-80 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[2]}
      src={bodysc}
      alt="imgm 3"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Body Sculpting
    </p>
  </div>

  {/* Analysers */}
  <div className="absolute top-0 right-32 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[3]}
      src={analy}
      alt="imgm 4"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Analysers
    </p>
  </div>


  <div className="absolute top-0 right-80 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[4]}
      src={skintight}
      alt="imgm 4"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Skin Tightening
    </p>
  </div>

  {/* Skin Lifting */}
  <div className="absolute bottom-28 right-0 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[5]}
      src={skinlift}
      alt="imgm 5"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Skin Lifting
    </p>
  </div>

  {/* HydraFacial */}
  <div className="absolute bottom-0 right-80 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[6]}
      src={hydra}
      alt="imgm 6"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      HydraFacial
    </p>
  </div>

  {/* Body Sculpting */}
  <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[7]}
      src={skintight}
      alt="imgm 7"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
      Body Sculpting
    </p>
  </div>

  {/* Hair Regrowth */}
  <div className="absolute top-96  transform translate-x-1/2 text-center flex flex-col items-center space-y-2">
    <img
      ref={cardRefs[7]}
      src={hairgrowth}
      alt="imgm 8"
      className="w-24 h-24 rounded-full shadow-md hover:shadow-lg transition-shadow"
    />
    <p className="border-2 border-colorPrimary text-colorPrimary bg-white rounded-lg px-4 py-2 font-semibold shadow-sm">
    Hair Regrowth
    </p>
  </div>
</div>

      </section>
      <div className="lg:hidden block">
        <ServicePage />
      </div>
    </>
  );
};

export default SectionCards;
